import Vue from 'vue'
import VueRouter from 'vue-router'
import Admin from '../views/Admin.vue'
import Anketa from '../views/Anketa.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import PageNotFound from '../views/PageNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/anketa/:id',
    name: 'Anketa',
    component: Anketa
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  { path: "*", component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
